import Header from '@/components/site/Header';
import Hero from '@/components/site/Hero';
import TrustMetrics from '@/components/site/TrustMetrics';
import About from '@/components/site/About';
import Founders from '@/components/site/Founders';
import Services from '@/components/site/Services';
import InvestmentSolutions from '@/components/site/InvestmentSolutions';
import WhyChoose from '@/components/site/WhyChoose';
import Testimonials from '@/components/site/Testimonials';
import Process from '@/components/site/Process';
import FAQ from '@/components/site/FAQ';
import Contact from '@/components/site/Contact';
import Footer from '@/components/site/Footer';
import Floating from '@/components/site/Floating';

export default function Home() {
    return (
        <div className="min-h-screen bg-white">
            <Header />
            <main>
                <Hero />
                <TrustMetrics />
                <About />
                <Founders />
                <Services />
                <InvestmentSolutions />
                <WhyChoose />
                <Testimonials />
                <Process />
                <FAQ />
                <Contact />
            </main>
            <Footer />
            <Floating />
        </div>
    );
}
